import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { useState } from "react";
import httpService from "../../../services/http.service";
import SettingNavbar from "./settingNav";
import ErrorMessage from "../../common/errorMsg";

function UserActionReport(props) {
    const [userReportArray, setUserReportArray] = useState([])

    const getAllUserReport = async () => {
        await httpService.get('getalluserreport').then((res) => {
            if (res.data.ack === '1') {
                setUserReportArray(res.data.data)
            }
            else setUserReportArray([])
        })
            .catch((err) => {
                if (err && err.response && err.response.status == 401) {
                  ErrorMessage("Session expired, please login again")
                }
                setUserReportArray([])
                return
              });
            
    }

    useEffect(() => {
        getAllUserReport();
    }, [])

    const defaultColDef = {
        sortable: true,
        editable: false,
        flex: 1,
        filter: true,
    };

    const actioncolumns = [
        {
            headerName: "User Name",
            field: "Username",
            tooltipField: "Username",
        },
        {
            headerName: "Account No",
            field: "AccountNo",
            tooltipField: "AccountNo",
        },
        {
            headerName: "Deletion Time",
            field: "TimeCreated",
            tooltipField: "TimeCreated",
        },
    ];
    return (
        <div style={{ margin: "15px" }}>
            <SettingNavbar activeTab={"userActionReport"} />
            <div className='pad-15 mt-5' >
                <div className="form-boxdiv">
                    <div className="form-boxtopline5">Deleted Users Report</div>
                    <div className="form-boxtopcont user-form">
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "calc(100vh - 325px)" }}
                        >
                            <AgGridReact
                                //   onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={20}
                                columnDefs={actioncolumns}
                                defaultColDef={defaultColDef}
                                enableBrowserTooltips={true}
                                tooltipShowDelay={{ tooltipShowDelay: 0 }}
                                rowData={userReportArray}
                            ></AgGridReact>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-4"></div>
            <div className="text-end col-4" style={{ marginTop: "15px" }}></div>
        </div>)

}

export default UserActionReport;